import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full px-0 sm:px-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, null, -1)
const _hoisted_3 = { class: "md:w-[768px] w-full flex flex-col border-t border-zinc-200 border-solid" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "w-20 bg-red-00 flex justify-center items-start mr-2" }
const _hoisted_6 = { class: "bg-zinc-50 ring-1 ring-zinc-200 rounded-full px-2 py-1 justify-center flex items-center text-xs" }
const _hoisted_7 = { class: "flex-col flex" }
const _hoisted_8 = { class: "text-sm text-def" }
const _hoisted_9 = { class: "text-xs font-medium text-sub" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-40" }, null, -1)

import { formatDate } from '@/utils/formattedUnit';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'NoticeList',
  setup(__props) {

const router = useRouter();
const store = useStore();
const route = useRoute();

const handlePost = (post) => {
    router.push({ path: `/mobile/notice/${post.id}` });
}
const noticeList = [
    {
        id : 1,
        title : '공지 / 파충류 다 있다 이용 수칙 안내',
        link : 'https:/naver.com',
        created_at : '2023-10-06T09:05:04.000Z'
    },
    {
        id : 2,
        title : '공지 / 커뮤니티 신고 처리 방침',
        link : 'https:/naver.com',
        created_at : '2023-10-06T09:05:04.000Z'
    },
]


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(noticeList, (post) => {
        return _createElementVNode("ul", {
          key: post.id,
          class: ""
        }, [
          _createElementVNode("li", {
            onClick: ($event: any) => (handlePost(post)),
            class: "cursor-pointer flex h-20 pt-5 border-b border-zinc-200 border-solid"
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(post.title.slice(0,2)), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(post.title.slice(4)), 1),
              _createElementVNode("p", _hoisted_9, _toDisplayString((post.created_at).slice(0, 10)), 1)
            ])
          ], 8, _hoisted_4)
        ])
      }), 64))
    ]),
    _hoisted_10
  ]))
}
}

})